/**
 * Procedure Categories and Procedures for DM in Organ Transplant Anaesthesia and Critical Care students
 * Extracted with strict evidence from official NMC PDF (Page 1, 4-5: "Psychomotor Domain - Perform Independently")
 */
export const ORGAN_TRANSPLANT_ANAESTHESIA_PROCEDURES = {
  "Anaesthetic, Airway & Vascular Access Procedures for Organ Transplantation": [
    "Preoperative Anaesthetic Assessment for Organ Donation & Organ Recipients",
    "Conduct of Anaesthesia for Organ Retrieval & Organ Harvesting",
    "Conduct of Anaesthesia for Live & Deceased Donor Organ Transplantation",
    "Peripheral & Central Venous Line Placement & Invasive Arterial Line Monitoring",
    "Rescue Airway Management (Front-of-Neck Rescue Airway, Tracheostomy & Fiberoptic Intubation)",
    "Use of Specialised Intraoperative Equipment (Cell Saver, Rapid Infusers, Point-of-Care Coagulation, Depth of Anaesthesia)",
  ],
  "Transplant ICU, Organ Support & Interventional Procedures": [
    "Postoperative ICU Care & Management of Organ Recipients",
    "Invasive Chest Drain Insertion, Suprapubic Catheterization & Dialysis Catheter Insertion",
    "Advanced Mechanical Ventilation & Weaning Protocols",
    "Echocardiography (TEE & TTE) & Transcranial Doppler (TCD) Monitoring",
    "Advanced Organ Support Systems (Renal Replacement Therapy / RRT, IABP, ECMO, MARS, Ventricular Assist Devices)",
  ],
};

export const ORGAN_TRANSPLANT_ANAESTHESIA_CATEGORIES = Object.keys(ORGAN_TRANSPLANT_ANAESTHESIA_PROCEDURES);

export const isDMInOrganTransplantAnaesthesiaDept = (department) => {
  if (!department) {
    try {
      const u = JSON.parse(
        localStorage.getItem("userData") || localStorage.getItem("user") || "{}"
      );
      department = u.department || (u.departments && u.departments[0]);
    } catch (e) {}
  }
  if (!department) return false;
  const d = String(department).toLowerCase();
  return (
    d.includes("organ transplant") ||
    d.includes("transplant anaesthesia") ||
    d.includes("transplant anesthesia")
  );
};
